import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {NgForm} from "@angular/forms";
import {lastValueFrom} from "rxjs";
import {ChangePasswordRequest, PerFormaAPIService, ProfileResponse} from "src/app/services/pfapi.service";

@Component({
    selector: "app-change-password",
    templateUrl: "./change-password.component.html",
    styleUrls: ["./change-password.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
    profile: ProfileResponse;
    error = "";
    success = false;
    constructor(private readonly api: PerFormaAPIService) {}
    async ngOnInit() {
        const profile = await lastValueFrom(this.api.getApiProfile());
        this.profile = profile;
    }

    handleSubmit = async (frm: NgForm) => {
        this.error = "";
        this.success = false;
        if (!frm.valid) {
            console.log(frm.errors);
            return;
        }
        const req = frm.value as ChangePasswordRequest & {NewPasswordAgain?: string};
        if (req.NewPassword !== req.NewPasswordAgain) {
            this.error = "New Password and New Password Again must match";
            return;
        }
        try {
            await lastValueFrom(this.api.postApiProfileChangePassword(req));
            this.success = true;
            frm.reset();
            this.profile.ForcePasswordChange = false;
        } catch (err) {
            const defaultMessage = err?.error?.ModelState?.[""];
            this.error = defaultMessage || err?.error?.Message;
        }
    };
}
